var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaiconnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-nia426",
    "aria-label": "area",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21H13.5 M13.5 3H10.5 M21 13.5V10.5 M3 10.5V13.5 M21 7V5C21 3.895 20.105 3 19 3H17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 17V19C3 20.105 3.895 21 5 21H7 M7 3H5C3.895 3 3 3.895 3 5V7 M17 21H19C20.105 21 21 20.105 21 19V17"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaiconnew);
export default __webpack_public_path__ + "static/media/areaiconnew.4a3f1266d4d6b642d2dfe2253f89e06e.svg";
export { ForwardRef as ReactComponent };